
export { HorizontalProductCardSkeleton } from "/codebuild/output/src3584820406/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src3584820406/src/packages/shared-components/src/components/ProductCard/index.ts"